import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/close/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

/**
 * A button for closing dialogs, overlays, etc.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export function CloseIconButton(props: LocalizedIconButtonProps) {
  const label = useLocalizedString(labelTranslations);
  return <IconButton icon="x" aria-label={label} {...props} />;
}
